<template>
  <div class="mask transition-all w-100"></div>
</template>

<script>
export default {
  name: "br-mask",
};
</script>
<style lang="css">
.mask {
  width: 100%;
  height: 100%;
  display: block;
  position: fixed;
  background: #444040;
  z-index: 70;
  opacity: 0.5;
}
</style>
